import { render, staticRenderFns } from "./DealerList.vue?vue&type=template&id=5e764dd9&scoped=true&lang=html&"
import script from "./DealerList.vue?vue&type=script&lang=js&"
export * from "./DealerList.vue?vue&type=script&lang=js&"
import style0 from "./DealerList.vue?vue&type=style&index=0&id=5e764dd9&lang=scss&scoped=true&"
import style1 from "./DealerList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e764dd9",
  null
  
)

export default component.exports